export const MEMBERS_INDEX = '/account/members';
export const SETTINGS = '/account/settings';
export const SUBSCRIPTION = '/subscription';
export const SUBSCRIPTION_INVOICES = '/subscription/invoices';
export const SUBSCRIPTION_COUPONS = '/subscription/coupons';
export const INTEGRATIONS = '/integrations';
export const INTERMEDIARIES = '/intermediaries';
